<template>
  <div class="m3u8-video-box">
    <video
      id="videoM3U8"
      ref="videoM3U8"
      class="video-js"
      preload="none"
      webkit-playsinline=""
      x-webkit-airplay="allow"
      playsInline=""
      x5-playsinline=""
      x5-video-orientation="portraint"
    />
  </div>
</template>

<script>
import videojs from 'video.js'
import 'videojs-contrib-hls'

export default {
  props: {
    videoUrl: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // livingUrl: 'http://hls.cntv.myhwcdn.cn/asp/hls/main/0303000a/3/default/0896002f5b89404b97e0f0c7285891bc/main.m3u8?maxbr=2048',
      livingPlayer: null,
      options: {
        autoplay: false,
        muted: false,
        controls: true,
        loop: true,
        notSupportedMessage: '视频出错'
      },
      playerType: 'application/x-mpegURL' // video/mp4
    }
  },
  watch: {
    videoUrl: {
      handler (newVal) {
        this.getVideo(newVal)
      },
      immediate: true
    }
  },
  beforeDestroy () {
    if (this.livingPlayer) this.livingPlayer.dispose()
  },
  methods: {
    getVideo (videoUrl) {
      setTimeout(() => {
        this.livingPlayer = videojs('videoM3U8', this.options)
        this.livingPlayer.src([
          { src: videoUrl } // , type: this.playerType
        ])

        this.livingPlayer.on('playing', () => {
          this.$emit('onVideoPlay')
        })
        this.livingPlayer.on('pause', () => {
          this.$emit('onVideoPause')
        })
        this.livingPlayer.on('ended', () => {
          this.$emit('onVideoEnd')
        })
      }, 200)
    }
  }
}
</script>

<style lang="scss" scoped>
.m3u8-video-box {
  width: 100%;
  height: 100%;
  .video-js {
    width: 100%;
    height: 100%;
  }
}

</style>
<style lang="scss">
.m3u8-video-box {
  // .video-js {
    // font-size: 16px;
  // }
  .video-js .vjs-big-play-button {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
